export default "__VITE_ASSET__Dj7j3K1H__"